<template>
    <div class="material">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="耗材规格">
                    <el-input v-model.trim="filters.menuSpec" clearable></el-input>
                </el-form-item>
                <el-form-item label="耗材名称">
                    <el-input v-model.trim="filters.menuName" clearable></el-input>
                </el-form-item>
                <el-form-item label="厂家">
                    <el-input v-model.trim="filters.manufacturers" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="buttonText">
                <el-button type="warning" @click="add" icon="el-icon-plus">新增</el-button>
                <el-button type="danger" @click="delAll" icon="el-icon-delete">批量删除</el-button>
                <!-- <div class="delete" @click="delAll">批量删除</div>
                <div class="addData" @click="add">新增</div> -->
            </div>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="id" label="编号" align="center"></el-table-column>
                <el-table-column sortable prop="menuName" label="耗材名称"></el-table-column>
                <el-table-column sortable prop="menuSpec" label="耗材规格"></el-table-column>
                <el-table-column sortable prop="manufacturers" label="厂家"></el-table-column>
                <el-table-column sortable prop="createBy" label="添加人"></el-table-column>
                <el-table-column sortable prop="createTime" label="添加时间" width="100"></el-table-column>
                <el-table-column sortable align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="del(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="forbidden" label="禁用" width="80">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.forbidden" active-color="#13ce66" inactive-color="#C9C9C9" :inactive-value="0" :active-value="1" @change="change(scope.$index, scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <!-- 新增编辑身份弹框 -->
        <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
            <el-form :model="formData" label-width="90px">
                <el-form-item label="耗材名称">
                    <el-input v-model.trim="formData.menuName" style="width:95%;" @input="testSX">
                    </el-input>
                </el-form-item>
                <div>
                    <div class="flex" v-for="(domain, index) in formData.consumableMenuDtoList" :key="index">
                        <el-form-item label="规格">
                            <el-input v-model.trim="domain.menuSpec" placeholder="请输入规格"></el-input>
                        </el-form-item>
                        <el-form-item label="标准成本">
                            <el-input v-model.trim="domain.price" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="核算成本">
                            <el-input v-model.trim="domain.accountingPrice" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="厂家">
                            <el-input v-model.trim="domain.manufacturers" placeholder="请输入厂家"></el-input>
                        </el-form-item>
                        <el-button size="mini" type="danger" @click.prevent="editRemoveDomain(domain,index)" v-show="index > 0">
                            <i class="el-icon-delete"></i>
                        </el-button>
                    </div>
                    <el-form-item style="text-align: right;margin-right:5%;">
                        <el-button @click="editAddDomain" type="primary" size="mini">添加规格</el-button>
                    </el-form-item>
                </div>
                <div>
                    <div v-for="(domain, idx) in formData.areaList" :key="idx">
                        <div class="instrucPosition">
                            <el-form-item label="院区/科室">
                                <el-select @input="testSX" @focus="areaFocus($event,idx)" v-model="domain.areaId" placeholder="请选择院区" style="width:45%;float:left;margin-left:2.5%;">
                                    <el-option v-for="(item) in areaList" :key="item.areaCode" :label="item.areaName" :value="item.areaCode" :disabled="item.disabled"> </el-option>
                                </el-select>
                                <el-select multiple v-model="domain.departmentCode" placeholder="请选择科室" style="width:43%;margin-right:5.1%;">
                                    <el-option v-for="(item) in offices" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                                </el-select>
                                <el-button size="mini" type="danger" @click.prevent="removeArea(domain)">
                                    <i class="el-icon-delete"></i>
                                </el-button>
                            </el-form-item>
                        </div>
                    </div>
                    <el-form-item style="text-align: right;margin-right:5%;">
                        <el-button @click="addArea" type="primary" size="mini">新增院区</el-button>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer partFooter">
                <el-button type="danger" @click="dialogFormVisible=false">取 消</el-button>
                <el-button type="primary" @click="doAddgoods()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
export default {
    name: "consumable",
    computed: {
        ...mapState(['areaOptions']),
    },
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
            },
            tableData: [],
            multipleSelection: [],
            dialogFormVisible: false,
            formData: {
                consumableMenuDtoList: [
                    {
                        menuName: '',
                        menuSpec: '',
                        price: '',
                        manufacturers: "",
                        accountingPrice: "",
                    }
                ]
            },
            tableHeight: "",
            isId: '',
            areaList: [],
            offices: [
                {
                    name: '美容皮肤科',
                    id: '001'
                },
                {
                    name: '美容外科',
                    id: '002'
                },
                {
                    name: '注射微整科',
                    id: '003'
                },
            ],
        }
    },
    created() {
        console.log(this.areaOptions);
        this.areaList = this.areaOptions
        this.tableHeight = document.documentElement.clientHeight - 380
    },
    mounted() {
        /*this.init();*/
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        addArea() {
            this.formData.areaList.push({
                areaId: '',
                departmentCode: '',
                key: Date.now()
            });
            this.$forceUpdate()
        },
        removeArea(item) {
            var index = this.formData.areaList.indexOf(item)
            if (index !== -1) {
                this.formData.areaList.splice(index, 1)
            }
            this.$forceUpdate()
        },
        // 判断是否添加重复院区
        areaFocus(val, index) {
            this.areaList = [{
                areaName: '上伯',
                areaCode: '001'
            }, {
                areaName: '上百',
                areaCode: '002'
            }, {
                areaName: '上翡',
                areaCode: '003'
            }, {
                areaName: '北百',
                areaCode: '004'
            }, {
                areaName: '温伯',
                areaCode: '005'
            }, {
                areaName: '重百',
                areaCode: '006'
            }, {
                areaName: '南伯',
                areaCode: '007'
            }]
            this.formData.areaList.map((x, i) => {
                this.areaList.map((s) => {
                    if (x.areaId == s.areaCode) {
                        s.disabled = true
                    }
                })
            })
            this.$forceUpdate()
        },
        testSX() {
            this.$forceUpdate()
        },
        // 编辑时新增部位
        editAddDomain(index) {
            this.formData.consumableMenuDtoList.push({
                key: Date.now(),
                menuName: '',
                menuSpec: '',
                price: '',
                manufacturers: '',
                accountingPrice: ""
            });
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        // 编辑时删除部位
        editRemoveDomain(item, listIndex) {
            var index = this.formData.consumableMenuDtoList.indexOf(item)
            if (index !== -1) {
                this.formData.consumableMenuDtoList.splice(listIndex, 1)
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        // 新增项目
        add() {
            this.dialogFormVisible = true
            this.isId = ''
            // 新增置空
            this.formData = {
                menuName: "",
                consumableMenuDtoList: [
                    {
                        menuName: '',
                        menuSpec: '',
                        price: '',
                        manufacturers: '',
                        accountingPrice: "",
                    }
                ],
                areaList: [{
                    areaId: '',
                    departmentCode: '',
                }],
            }
        },

        handleEdit(index, row) {
            console.log(row);
            this.isId = row.id
            this.dialogFormVisible = true
            let querys = {
                id: row.id,
            }
            api.request('/skn/findConsumableMenuById', querys, (res) => {
                this.formData = res.data
                this.formData.areaList.forEach(item => {
                    item.departmentCode = item.departmentCode.split(',')
                });
                this.$forceUpdate()
            })
        },
        doAddgoods() {
            this.formData.areaList.forEach(item => {
                item.departmentName = []
                this.areaOptions.forEach(ele => {
                    if (ele.areaCode == item.areaId) {
                        item.areaName = ele.areaName
                    }
                });
                this.offices.forEach(ite => {
                    item.departmentCode.forEach(ele => {
                        if (ite.id == ele) {
                            item.departmentName.push(ite.name)
                        }
                    });
                });
                item.departmentCode = item.departmentCode.toString()
                item.departmentName = item.departmentName.toString()
            });
            this.formData.createBy = Lockr.get('skinEmpId')
            console.log(this.formData);
            if (this.isId) {
                api.requestQuiet("/skn/updateConsumableMenu", this.formData, (res) => {
                    if (res.result == true) {
                        this.dialogFormVisible = false
                        _g.toast("success", '修改成功');
                        this.query(this.filters.pagination.page)
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            } else if (!this.isId) {
                api.requestQuiet("/skn/createConsumableMenu", this.formData, (res) => {
                    if (res.result == true) {
                        this.dialogFormVisible = false
                        _g.toast("success", '添加成功');
                        this.query(this.filters.pagination.page)
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            }

        },
        change(index, row) {
            let data = {
                id: row.id
                // 0：正常 1：禁用
            }
            api.request("/skn/updateConsumableMenuForbidden", data, (res) => {
                if (res.result == true) {
                    _g.toast("success", "状态修改成功")
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", "状态修改失败")
                    this.query(this.filters.pagination.page)
                }
            })
        },
        // 删除项目
        del(index, row) {
            let querys = {
                id: row.id,
            }
            this.$confirm('确定要该条数据吗？', '删除项目', {
                center: true
            })
                .then((res) => {
                    api.request("/skn/deleteConsumableMenuById", querys, (res) => {
                        if (res.result == true) {
                            _g.toast("success", "删除成功")
                            this.query(this.filters.pagination.page)
                        } else {
                            _g.toast("error", "删除失败")
                            this.query(this.filters.pagination.page)
                        }
                    })
                }).catch((err) => {
                    // this.$message.error('删除失败！');
                })
        },
        // 批量删除
        delAll() {
            var data = this.multipleSelection;
            var id = [];
            data.map(function (item, index) {
                console.log(item)
                id.push(item.id);
            });
            this.$confirm("确定要删除选中的数据吗？", "删除项目", {
                center: true,
            })
                .then((res) => {
                    api.requestQuiet(
                        "/skn/deleteConsumableMenuAll", {
                            idList: id.toString(),
                        },
                        (res) => {
                            if (res.result == true) {
                                _g.toast("success", "删除成功");
                                this.query(this.filters.pagination.page);
                            } else {
                                _g.toast("error", "删除失败");
                                this.query(this.filters.pagination.page);
                            }
                        }
                    );
                })
                .catch((err) => {
                    // this.$message.error('删除失败！');
                });
        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
                menuSpec: this.filters.menuSpec,
                menuName: this.filters.menuName,
                manufacturers: this.filters.manufacturers
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            // console.log(querys)
            api.request('/skn/findConsumableMenuPage', querys, (res) => {
                // console.log(res)
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
    },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.material >>> .el-dialog {
  width: 70% !important;
}
.flex {
  display: flex;
  align-items: flex-start;
}
.flex >>> .el-button i {
  margin: 0 !important;
}
.flex >>> .el-button--mini {
  margin: 8px;
}
</style>